<template>
  <header>
    <div style="max-width: 95%; margin:auto; margin-top: 1%">

      <div :class="[isMobile ? 'mobile-header' : 'desktop-header']">

        <div v-if="isMobile" class="mobile-logo-container" style="padding-top: 5%;">

          <router-link v-if="step != 0" :to="path">

            <v-icon style=" width: 7px; height: 14px; position: absolute; left:10%; color: rgba(35, 35, 35, 1);">
              mdi-chevron-left
            </v-icon>

          </router-link>

          <router-link v-else :to="path">

            <v-icon @click="sitio()"
              style=" width: 7px; height: 14px; position: absolute; left:10%; color: rgba(35, 35, 35, 1);">
              mdi-chevron-left
            </v-icon>

          </router-link>

          <router-link :to="{ path: '/' }">
            <img :src="logo" alt="logo" width="130px" class="mobile-logo">
          </router-link>

        </div>

        <div v-else class="desktop-logo-container" style=" padding-left: 3%;">

          <router-link :to="{ path: '/' }">

            <img :src="logoNav" alt="Image 1" class="menu-nav"
              style="padding-top: 15px; float: right; padding-right: 39px; max-height: 50px; max-width: 50%;">

          </router-link>

          <div>

            <router-link :to="path">

              <div v-if="step == 0">

                <v-icon @click="sitio()"
                  style=" width: 20px; height: 20px; color: rgba(51, 51, 204, 1); font-size: 40px; padding-top: 29.5px;">
                  mdi-chevron-left
                </v-icon>

                <span @click="sitio()" class="textoH3" style="margin-left: 10px;">Volver atrás</span>


              </div>

              <div v-else>

                <v-icon
                  style=" width: 20px; height: 20px; color: rgba(51, 51, 204, 1); font-size: 40px; padding-top: 29.5px;">
                  mdi-chevron-left
                </v-icon>

                <span class="textoH3" style="margin-left: 10px;">Volver atrás</span>

              </div>

            </router-link>

          </div>

        </div>

      </div>

    </div>

    <br>

  </header>
</template>
<script>
import logo from '@/assets/MercerMarsh.png';
import logoNav from '@/assets/MercerMarsh.png';
export default {
  name: 'MyHeader',
  props: ['step', "userData", "beneficiaries"], // Prop para pasar datos adicionales del botón de retroceso
  data() {
    return {
      displayOptions: false,
      smallScreen: false,
      logo,
      logoNav,
      isMobile: false,
      path: '',
      screen: window.screen.width,
    };
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 789;
    },
    emitBackButton() {
      this.$router.push({ name: `${this.path}`, params: { beneficiaries: this.beneficiaries } });
    },
    sitio() {
      //window.location.href = "https://www.segurofacil.cl/"
    }
  },
  mounted() {

    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    if (this.step == 0) {
      // console.log("volver inicio")
      this.path = {
        name: ""
      }
    } else if (this.step == 1) {
      // console.log("perro o gato")
      this.path = {
        name: "Step1"
      }
    } else if (this.step == 2) {
      // console.log("volver a step2")
      this.path = {
        name: "Step2", params: { beneficiaries: this.beneficiaries, userData: this.userData }
      }
    } else if (this.step == 3) {
      // console.log("volver a planes")
      if (screen > 800) {
        this.path = {
          name: "PlanEscritorio", params: { beneficiaries: this.beneficiaries, userData: this.userData }
        }
      } else {
        this.path = {
          name: "PlanMovil", params: { beneficiaries: this.beneficiaries, userData: this.userData }
        }
      }
    } else if (this.step == 4) {
      // console.log("volver a datos")
      this.path = {
        name: "Step4", params: { beneficiaries: this.beneficiaries, userData: this.userData }
      }
    } else if (this.step == 5) {
      // console.log("volver a agregar data benef")
      this.path = {
        name: "step5", params: { beneficiaries: this.beneficiaries, userData: this.userData }
      }
    } else if (this.step == 6) {
      // console.log("volver a agregar data")
      this.path = {
        name: "Datos", params: { beneficiaries: this.beneficiaries, userData: this.userData }
      }
    }

  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
<style lang="scss">
/* Estilos para el desktop */
.desktop-header {
  height: 65px;
  background: #FFFFFF;
  border: 2px solid rgba(0, 44, 119, 1);
  box-shadow: 0px 24px 30px rgba(0, 0, 0, 0.03);
  border-radius: 15px;

  .desktop-logo {
    width: 270px;
    height: 60px;
  }

  .desktop-images {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

    img {
      max-width: 200px;
      max-height: 200px;
    }
  }
}

/* Estilos para mobile */
.mobile-header {
  .mobile-logo {
    display: flex;
    flex-direction: column;
    right: 0;
    justify-content: space-around;
  }
}

.mobile-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.iconStyle {
  width: 20px;
  height: 20px;
  color: rgba(51, 51, 204, 1);
  font-size: 40px;
  padding-top: 29.5px;
}

.textoH3 {
  position: absolute;
  width: 127px;
  height: 22px;
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  padding-top: 23px;
  /* primary */
  color: rgba(0, 44, 119, 1);
}
</style>
